import { Link } from "react-router-dom";

const WhatsAppButton = () => {
  return (
    <Link
      to="https://wa.me/917385743121?text=Hi%20I%20want%20more%20info"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp_float"
    >
      <img
        src="https://cdn-icons-png.flaticon.com/512/124/124034.png"
        width="55"
        alt="WhatsApp"
        className="whatsappimg"
      />
    </Link>
  );
};

export default WhatsAppButton;
